import italianCuisine from "../areas/onboarding/images/cuisine/italian.jpg";
import japaneseCuisine from "../areas/onboarding/images/cuisine/japanese.jpg";
import indianCuisine from "../areas/onboarding/images/cuisine/indian.jpg";
import frenchCuisine from "../areas/onboarding/images/cuisine/french.jpg";

export const config = {
    CognitoClientId: process.env.GATSBY_COGNITO_CLIENT_ID,
    UserPoolId: process.env.GATSBY_COGNITO_USERPOOL_ID,
    CognitoUrl: process.env.GATSBY_COGNITO_URL,
    AdminUrl: process.env.GATSBY_ADMIN_URL,
    MenuApiUrl: process.env.GATSBY_MENU_API_URL,
    ClientApiHost: process.env.GATSBY_PUBLIC_CLIENT_URL,
    MenuApiKey: process.env.GATSBY_MENU_API_KEY,
    MenuTemplates: [
        {
            titleKey: "italian-cuisine",
            image: italianCuisine,
            spreadsheetId: "1rCwXSNPRuiJbeKffI2swp_6VFdOqn5RhVwBNLw3KIP8",
        },
        {
            titleKey: "japanese-cuisine",
            image: japaneseCuisine,
            spreadsheetId: "1OYiQkIgnjMd4wdIBdA9oj6p6U4eK6zHODjzlV_dMiFQ",
        },
        {
            titleKey: "indian-cuisine",
            image: indianCuisine,
            spreadsheetId: "1hAipyIMzWuITU-ABfn4Vg7h6ezriySmfXyCvmqTqUJY",
        },
        {
            titleKey: "french-cuisine",
            image: frenchCuisine,
            spreadsheetId: "1iEvA9sNXJnyMc-AD_aHKGwNO5lTEb8-d55d9TOchroo",
        }
    ]
}   